import { createSelector } from 'reselect';
import { getCompanySettings } from './getCompanySettings';

export const getIsErpJobDispatchEnabled = createSelector(
  [getCompanySettings],
  (companySettings) => {
    return companySettings?.erpJobDispatchEnabledAt != null;
  }
);
